import { Injectable } from '@angular/core';
import { ParentService } from '../pages/A2-utils/ParentClass/ParentService';
import { Router } from '@angular/router';
import { constant } from '../app.constants';
import { Observable } from 'rxjs/Observable';
import { Http, Response } from '@angular/http';

export interface IDriver {
  code: number,
  driver: string,
  count: number,
  hasintegration: boolean
}


@Injectable()
export class AutoRoutingService  extends ParentService {

  constructor(private _http: Http, private route: Router) {
    super();
  }

  getDrivers(jobId) {
    const endpoint = constant.URL_AUTO_ROUTING_DRIVERS.replace('$jobId', jobId);
    return this._http.get(endpoint, this.getHeader()).map(
      res => res.json()
    );
  }

  getUnassignedTrips(jobId) {
    const endpoint = constant.URL_AUTO_ROUTING_UNASSIGNEDTRIPS.replace('$jobId', jobId);
    return this._http.get(endpoint, this.getHeader()).map(
      res => res.json()
    );
  }

  getTripsForVehicle(jobId, scheduleId) {

      let endpoint = constant.URL_AUTO_ROUTING_VEHICLES_TRIPS.replace('$jobId', jobId);
      endpoint = endpoint.replace('$scheduleId', scheduleId);
      return this._http.get(endpoint, this.getHeader()).map(
        res => res.json()
      );

  }

  putErase(data: any) {
    const bodyString = JSON.stringify(data);
    // return this._http.delete(constant.URL_AUTO_ROUTING_ERASE+ 'AutoRoutingJobId='+data.AutoRoutingJobId+'&ScheduleId='+data.ScheduleId+'&TripId='+data.TripId, this.headerPost())
    return this._http.put(constant.URL_AUTO_ROUTING_RECALCULATE + 'unassign?AutoRoutingJobId=' + data.AutoRoutingJobId + '&ScheduleId=' + data.ScheduleId + '&TripId=' + data.TripId, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  postAssign(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.URL_AUTO_ROUTING_ASSIGN, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }


  changeOrder(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.put(constant.URL_AUTO_ROUTING_CHANGE_ORDER, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  recalculateSchedule(jobId, scheduleId) {
    const endpoint = constant.URL_AUTO_ROUTING_RECALCULATE + `${jobId}/${scheduleId}/updateRouteTimes`;
    return this._http.put(endpoint, ' ', this.headerPost()).map(
      res => res.json()
    );
  }

  approbeJob(data) {
    const body = JSON.stringify(data);
    const endpoint = constant.URL_AUTO_ROUTING_RECALCULATE + `acceptRoutes `;
    return this._http.put(endpoint, body, this.headerPost()).map(
      res => res.json()
    );
  }



}



// WEBPACK FOOTER //
// ./src/app/services/auto-routing.service.ts